module.exports = __webpack_public_path__ + "img/redtiger.c7836aff.svg";